import Vue from 'vue'
import Router from 'vue-router'
const notFound = () => import('@/views/NotFound')
const Home = () => import('@/views/Home')
const Privacy = () => import('@/views/Privacy')
const Resolution = () => import('@/views/Resolution')
const AboutUs = () => import('@/views/AboutUs')
const pdf1 = () => import('@/views/pdf1')
const pdf2 = () => import('@/views/pdf2')

Vue.use(Router)

export default new Router({
  mode: 'history',
  // fallback: false,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requireAuth: true,
        title: '泰坦智慧_TitanOS - 打造产业AI操作系统'
      }
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: {
        requireAuth: true,
        title: '泰坦智慧_TitanOS - 打造产业AI操作系统'
      }
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy,
      meta: {
        requireAuth: true,
        title: '隐私政策 - TitanOS'
      }
    },
    {
      path: '/resolution',
      name: 'resolution',
      component: Resolution,
      children: [
        {
          path: '/resolution/:type',
          component: Resolution,
          props: true
        }
      ]
    },{
      path: '/aboutus',
      name: 'aboutus',
      component: AboutUs,
      meta: {
        requireAuth: true,
        title: '关于我们 - TitanOS'
      }
    }, {
      path: '*',
      name: 'notFound',
      component: notFound,
      meta: {
        requireAuth: true,
        title: '404 - TitanOS'
      }
    }, {
      path: '/pdf1',
      name: 'pdf1',
      component: pdf1,
      meta: {
        requireAuth: true,
        title: 'pdf - TitanOS'
      }
    }, {
      path: '/pdf2',
      name: 'pdf2',
      component: pdf2,
      meta: {
        requireAuth: true,
        title: 'pdf - TitanOS'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js